// Shared helpers for re-validating the cart before any payment interaction.
// A checkout screen left open in one tab goes stale when the cart is emptied
// or checked out in another tab; these helpers stop the transaction and show
// a visible error instead of failing silently.

export function checkCartValid(cartId) {
    return fetch("/carts/" + cartId + "/validation", {credentials: "same-origin"})
        .then(response => {
            if (!response.ok) {
                throw new Error("Unable to verify cart (status " + response.status + ")");
            }
            return response.json();
        });
}

// Puts a message where the teller reads them and leaves the checkout alone.
// For a refusal that does not invalidate the cart — a captured card that is
// only a part tender still needs cash added and Apply Payments pressed — this
// is the one to reach for.
export function showCartMessage(message) {
    const flashArea = document.querySelector("#flash-area");
    if (flashArea) {
        flashArea.innerHTML = "";
        const alertEl = document.createElement("p");
        alertEl.className = "alert";
        alertEl.textContent = message;
        flashArea.appendChild(alertEl);
    } else {
        alert(message);
    }
}

// The same message, for a cart that can no longer be paid: the action that
// would take the money goes with it.
export function showCartError(message) {
    showCartMessage(message);
    const applyButton = document.querySelector("#apply-payments-button");
    if (applyButton) {
        applyButton.classList.add("hidden");
    }
}

// Runs proceed() only when the cart is still checkout-able; otherwise shows
// the server-provided error and runs the optional onInvalid callback. Fails
// closed: when the validity check errors (network failure, non-200 response)
// the payment interaction is blocked, because proceed() may trigger
// irreversible charges (e.g. confirming an already-created Stripe intent)
// that server-side guards cannot intercept.
export function withValidCart(cartId, proceed, onInvalid) {
    return checkCartValid(cartId)
        .then(data => {
            if (data.valid) {
                proceed();
            } else {
                showCartError(data.message);
                if (onInvalid) {
                    onInvalid();
                }
            }
        })
        .catch(error => {
            console.warn("Cart validity check failed; blocking payment interaction", error);
            showCartError("Unable to verify this cart. Please refresh the page and try again.");
            if (onInvalid) {
                onInvalid();
            }
        });
}

export function cartIdFromPage() {
    const el = document.querySelector("[data-checkout-payments-cart]");
    return el ? el.getAttribute("data-checkout-payments-cart") : null;
}
